t = require('app/scripts/views/internal/teacup-with-helpers')('org_detail_profile_info')

module.exports = t.renderable ({ displayName, enterpriseUI, isBusinessClass,
  permissionLevel, pLevelAltText, pLevelDisplayText, descriptionHtml,
  websiteHref, website, accountProblem, name, canEdit }) ->

  t.div '.tabbed-pane-header-details-name', ->

    t.h1 '.u-inline', ->
      t.text displayName

    if enterpriseUI
      t.span '.window-title-extra', ->
        t.icon 'enterprise'
        t.format 'enterprise'
    else if isBusinessClass
      t.span '.window-title-extra', ->
        t.icon 'business-class'
        t.format 'business-class'

    t.span '.window-title-extra', ->
      t.icon permissionLevel,
        title: pLevelAltText
      t.text pLevelDisplayText

  t.div '.tabbed-pane-header-details-content.markeddown', { dir: 'auto' }, ->
    if descriptionHtml?
      t.raw descriptionHtml

    if websiteHref?
      t.p ->
        t.a { href: websiteHref }, ->
          t.text website

    if accountProblem
      t.div { style: 'padding: 4px 8px; background-color: orange; margin-bottom: 8px;' }, ->
        t.p '.u-bottom', ->
          t.format 'oops-there-is-a-problem-with-your-billing-information-visit-billing-to-fix-it', { name }

  if canEdit
    t.a '.button-link.tabbed-pane-header-details-edit.js-edit-profile', { href: '#' }, ->
      t.icon 'edit', 'edit-profile'
